import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-filler-atom',
  templateUrl: './modal-filler-atom.component.html',
  styleUrls: ['./modal-filler-atom.component.scss'],
  imports: [CommonModule],
})
export class ModalFillerAtomComponent {
  @Input() index!: number;
  @Input() withBackdrop = true;

  // TODO: NEVER CALL OUTPUTS LIKE EXISTING JS EVENT, NEVER !
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<Event>();
  @Output() onClick = new EventEmitter<Event>();

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: Event): void {
    this.onClick.emit(event);
    event.preventDefault();
    event.stopPropagation();
  }

  onClicked(_event: Event): void {
    this.click.emit(_event);
    this.onClick.emit(_event);
  }
}
